import { useState, useEffect } from "react";

export function useScroll() {
    // const [lastScrollTop, setLastScrollTop] = useState(0);
    // const [bodyOffset, setBodyOffset] = useState(
    //     document.body.getBoundingClientRect()
    // );
    const [scrollY, setScrollY] = useState(0);
    // const [scrollX, setScrollX] = useState(bodyOffset.left);
    // const [scrollDirection, setScrollDirection] = useState();

    const listener = function (e) {
        // setBodyOffset(document.body.getBoundingClientRect());
        setScrollY(this.scrollY);
        // setScrollX(bodyOffset.left);
        // setScrollDirection(lastScrollTop > -bodyOffset.top ? "down" : "up");
        // setLastScrollTop(-bodyOffset.top);
        const scrollY = this.scrollY
        return {
            scrollY,
        };
    };

    useEffect(() => {
        window.addEventListener("scroll", listener);
        return () => {
            window.removeEventListener("scroll", listener);
        };
    });

    return {
        scrollY
    }

}